import React, { PureComponent } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { UAParser } from 'ua-parser-js';

import { checkNewEmployee, HSADateAddMinute } from './utility/common/GlobalHSA';
import { publicRoutes, employeeRoutes, claimRoutes, adminRoutes, agentRoutes, managerRoutes, toolsRoutes } from './utility/common/Routes';
import { setSnackbar, resetSnackbar, submitClientLog } from './actions';

import FourZeroFour from './components/common/FourZeroFour';
import RefreshPrompt from './components/common/RefreshPrompt';
import ReloginPrompt from './components/common/ReloginPrompt';
import ExtendSession from './components/common/ExtendSession';
import NotificationBar from './components/common/NotificationBar';
import TourMyOlympia from './components/common/modalforms/TourMyOlympia';
import ToolsSticky from './components/common/ToolsSticky';
import Analytics from './components/common/Analytics';
import Ebooks from './components/common/Ebooks';
import ObiLoading from './components/common/ObiLoading';

import stylesheet from './App.css'

const { REACT_APP_NAME, REACT_APP_TYPE, REACT_APP_VERSION } = process.env;

class App extends PureComponent {

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  handleSnackbarClose = () => {
    this.props.resetSnackbar();
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info){
    if(!this.props.lastClientLog || HSADateAddMinute(this.props.lastClientLog, 5) < new Date() ){
      const userinfo = (this.props.user)? {id: this.props.user.ID, type: this.props.user.TYPE} : {id: 'None', type: 'None'};
      const message = {...userinfo, version: REACT_APP_VERSION};
      var parser = new UAParser();
      this.props.submitClientLog(new Date(), error, this.props.location.pathname, message, this.props.token, parser.getResult());
    }
  }

  render() {
    
    const pRoutes = publicRoutes;
    const eRoutes = [...employeeRoutes, ...claimRoutes, ...adminRoutes];
    const aRoutes = [...agentRoutes, ...managerRoutes];

    const isNewEmployee = checkNewEmployee(this.props.user);

    if (this.state.hasError) {
      if(this.props.user?.ID){
        return <RefreshPrompt />;
      }
      else{
        return <ReloginPrompt />;
      }
    }
    return (
        <div>
          <Analytics />
          
          <ToolsSticky />
          <Switch>
          
            {this.props.blockList && Object.entries(this.props.blockList).map((value) => { 
              if(String(value[0]).includes('/')){
                return <Redirect from={value[0]} to={{ pathname: "/" , state: {redirectMessage: value[1]}}} />;
              }
              return false 
            })}

            <Redirect from="/partner/mylogin/newpassword/:id" to={{ pathname: "/login/update/:id", state: {from: "/partner/mylogin/newpassword/:id"} }} />
            <Redirect from="/mylogin/newpassword/:id" to={{ pathname: "/login/update/:id", state: {from: "/mylogin/newpassword/:id"} }} />

            <Redirect from="/mylogin/forgot-password" to={{ pathname: "/login/reset", state: {from: "/mylogin/forgot-password"} }} />
            <Redirect from="/partner/mylogin/forgot-password" to={{ pathname: "/partner/login/reset", state: {from: "/partner/mylogin/forgot-password"} }} />

            <Redirect from="/mylogin" to={{ pathname: "/login", state: {from: "/mylogin"} }} />
            <Redirect from="/partner/mylogin" to={{ pathname: "/partner/login", state: {from: "/partner/mylogin"} }} />
            <Redirect from="/tools/admin" to={{ pathname: "/tools", state: {from: "/tools/admin"} }} />

            <Redirect from="/myolympia" to={{ pathname: "/"}} />
            <Redirect from="/myolympia/update" to={{ pathname: "/update-card", state: {from: "/update-card"} }} />
            <Route path='/tools/ebook/:id' component={Ebooks}/>

            {pRoutes.map((route, i) => (
              <route.type
                key={i}
                exact={route.exact}
                path={route.path}
                theme={this.props.theme}
                render={() => (
                  <React.Suspense fallback={<ObiLoading/>}>
                    <route.component />
                  </React.Suspense>
                )}
                />
              ))}
            {this.props.user && eRoutes.map((route, i) => (
              <route.type
                key={i}
                exact={route.exact}
                path={route.path}
                component={route.component}
                componentName={route.componentName}
                theme={this.props.theme}
                authType={this.props.userType}
                isAdmin={this.props.isAdmin}
                newEmployeeCheck={isNewEmployee}

                missingPersonalInfo={this.props.user.MISSING_INFO}
                missingPersonalBanking={this.props.user.MISSING_BANKING}
                missingCompanyInfo={this.props.user.MISSING_COMPANY_INFO}
                missingCompanyBanking={this.props.user.MISSING_COMPANY_BANKING}


                bankingInfoWaived={this.props.bankingInfoWaived}


                pwResetRequired={this.props.user.REQUIRE_WEB_PASSWORD_RESET}
                onlineClaimEnabled={this.props.user.ONLINE_CLAIM_OK}
                auditState={this.props.user.EMPLOYEE_AUDIT_STATE}
                accountFrozen={this.props.user.FROZEN}
                isNonMemberAdmin={this.props.user.NON_MEMBER_ADMIN_ONLY}
                contractType={parseInt(this.props.user.CONTRACT_TYPE)}
                terminatedFlag={this.props.user.TERMINATED_FLAG}
                claimPeriodEnded={this.props.user.CLAIM_PERIOD_ENDED}

                token={this.props.token}
                expiry={this.props.expiry}
              />
            ))}
            {this.props.user && aRoutes.map((route, i) => (
              <route.type
                key={i}
                exact={route.exact}
                path={route.path}
                component={route.component}
                componentName={route.componentName}
                theme={this.props.theme}
                authType={this.props.userType}

                missingPersonalBanking={this.props.user.MISSING_PARTNER_BANKING}
                pwResetRequired={this.props.user.REQUIRE_WEB_PASSWORD_RESET}
                terminatedFlag={this.props.user.TERMINATED_FLAG}

                token={this.props.token}
                expiry={this.props.expiry}
              />
            ))}
            {toolsRoutes.map((route, i) => (
              <route.type
                key={i}
                exact={route.exact}
                path={route.path}
                component={route.component}
                theme={this.props.theme}
                userName={this.props.userName}
                token={this.props.toolsToken}
                expiry={this.props.toolsExpiry}
              />
            ))}
            <Route component={FourZeroFour} />
          </Switch>

          <NotificationBar />
          <TourMyOlympia />

          {this.props.expiry && this.props.user && <ExtendSession />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const isAdmin = (state?.auth?.user?.GROUP_ADMIN === 'Y')? 'Y' : 'N';
  const userType = state?.auth?.user?.TYPE;
  const userName = state?.tools?.username;

  const bankingInfoWaived = (state?.employer?.employer && state?.employer?.employer?.BANKING_INFO_WAIVED)? state?.employer?.employer?.BANKING_INFO_WAIVED : false;
  
  return {
    user: state.auth.user,
    company: state.employer.employer,
    isAdmin,
    userType,
    bankingInfoWaived,
    userName,
    lastClientLog: state.general.lastClientLog,
    error: state.auth.error,
    loading: state.auth.loading,
    token: state.auth.token,
    expiry: state.auth.expiry,
    toolsToken: state.tools.token,
    toolsExpiry: state.tools.expiry,
    chosenTheme: state.general.chosenTheme,
    blockList: state.auth.blockList
  };
};

export default connect(mapStateToProps, {
  setSnackbar,
  resetSnackbar,
  submitClientLog,
})(withRouter(App));
